module.exports = __webpack_public_path__ + "img/terms.41c84a39.png";